import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { Heading as TipTapHeading } from '@tiptap/extension-heading';
export const Heading = TipTapHeading.extend({
    // Change to ctl + shift from mod + alt which breaks on euro and portuguese keyboards
    addKeyboardShortcuts () {
        return this.options.levels.reduce((items, level)=>_object_spread({}, items, {
                [`Ctrl-Shift-${level}`]: ()=>this.editor.commands.toggleHeading({
                        level
                    })
            }), {});
    },
    // Removing # + space shortcuts
    addInputRules () {
        return [];
    }
});

//# sourceMappingURL=heading.js.map